import React, { useEffect } from 'react';
import './BenefitsSection.scss';

const BenefitsSection = ({ benefitData }) => {
  const benefits = [
    benefitData?.Content1?.value,
    benefitData?.Content2?.value,
    benefitData?.Content3?.value,
    benefitData?.Content4?.value,
    benefitData?.Content5?.value,
    benefitData?.Content6?.value,
    benefitData?.Content7?.value,
    benefitData?.Content8?.value,
  ].filter(Boolean);

  return (
    <section className="benefits-section">
      <div className="container customContainer">
        <div className="benefits-header">
          <h2>{benefitData?.BenefitHeading?.value || ''}</h2>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <div className="benefit-bullet">
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4.5L4.5 8L11 1"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <p className="benefit-text">
                {benefit}

                {index === 1 && (
                  <span className="star-tooltip">
                    *<span className="tooltip-text">{benefitData?.GovtNorms?.value}</span>
                  </span>
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
